module.exports = __webpack_public_path__ + "static/media/card-product4.e00c5af4.jpg";